import * as React from "react";
export class Summary extends React.Component {
    setModifier() {
        return this.props.oddsModf ? ` rj-yourbet__selections-odds--${this.props.oddsModf}` : "";
    }
    render() {
        const mdfr = this.setModifier();
        return (React.createElement("div", { className: "rj-yourbet__summary rj-yourbet__section" },
            React.createElement("div", { className: "rj-yourbet__summary-selections rj-yourbet__summary-cell" },
                React.createElement("span", { className: "rj-yourbet__selections-txt-1" }, this.props.txt_1),
                " ",
                React.createElement("span", { className: "rj-yourbet__selections-txt-2", "data-uat": "bet-purchase-stake" }, this.props.txt_2),
                " @ ",
                React.createElement("span", { className: `rj-yourbet__selections-odds${mdfr}`, "data-uat": this.props.dataUat }, this.props.odds)),
            React.createElement("div", { className: "rj-yourbet__summary-return rj-yourbet__summary-cell" },
                React.createElement("span", { className: "rj-yourbet__return-label", "data-uat": "combo-bet-total-return-label" }, this.props.returnTxt),
                " ",
                React.createElement("span", { className: "rj-yourbet__return-value", "data-uat": "bet-slip-total-return-value" }, this.props.returnValue))));
    }
}
//# sourceMappingURL=Summary.js.map